<section class="benefits-section">
  <div class="container-fluid position-relative keyfeature-wrapper">
    <div class="row">
      <div class="container benefit-container">
        <div class="heading-wrapper">
          <h2 class="main-heading mb-1 text-white">
            {{ "benefits.umang-benefits" | translate }}
          </h2>
          <p class="text-white">
            {{ "benefits.umang-benefits-desc" | translate }}
          </p>
        </div>
        <div class="row benefit-row">
          <div class="col-md-7 benefit-col-left position-relative">
            <div class="benefit-card-list row">
              <!-- Benefits card -->
              <div
                *ngFor="let benefit of benefits"
                class="benefit-card-col col-md-6 col-sm-6"
              >
                <div class="benefit-card">
                  <div class="benefit-card__header d-flex flex-column">
                    <div class="benefit-thumbnail">
                      <img
                        imgFallback
                        loading="lazy"
                        [src]="benefit?.img"
                        alt="all-services"
                        width="52px"
                        height="52px"
                        class="resp-image mb-4"
                        fetchpriority="low"
                      />
                    </div>
                    <h4>{{ benefit.label | translate }}</h4>
                  </div>
                  <ul class="benefits-list-item">
                    <li
                      *ngFor="let chip of benefit.chips"
                      class="benefits-list-items"
                    >
                      <span class="benefits-list-items-label">{{
                        chip | translate
                      }}</span>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <picture class="avatar" width="570" height="764">
      <source
        srcset="https://media.umangapp.in/cdn/landing/theme/avatar.webp"
      />
      <img
        src="https://media.umangapp.in/cdn/landing/theme/avatar.png"
        width="570px"
        height="764px"
        loading="lazy"
        fetchpriority="low"
        alt="avatar"
      />
    </picture>
  </div>
</section>
